import { combineReducers } from "@reduxjs/toolkit";
import signup from "./signup";
import create from "./createPassword";
import login from "./login";
import forgot from "./forgotPassword";
import weather from "./weather";
import seasurface from "./seasurface";
import uploadImage from "./project/imageupload";
import createproject from "./project/createproject";
import updateproject from "./project/updateproject";
import vesselsReducer from "./vesselsSlice";
import portsReducer from "./portsSlice";
import lightHouseReducer from "./lightHouseSlice";
import summary from "./summarySlice";

const rootReducer = combineReducers({
  signup,
  create,
  forgot,
  weather,
  seasurface,
  login,
  createproject,
  updateproject,
  uploadImage,
  vessels: vesselsReducer,
  ports: portsReducer,
  lightHouses: lightHouseReducer,
  summary: summary,
});

export default rootReducer;
